import qs from 'qs';
import { z } from 'zod4';

import { positiveInteger } from '../../../lib/url/hooks/use-queries-control';

/**
 * Creates a Zod schema for validating manage-items params.
 * Handles pagination, search query, and filters (type, category, countryCode).
 */
export const createManageItemsParamsSchema = () => {
	return z
		.object({
			q: z.string().optional().nullable().catch(undefined),
			type: z
				.union([z.string().transform((s) => [s]), z.array(z.string())])
				.optional()
				.catch(undefined),
			category: z
				.union([z.string().transform((s) => [s]), z.array(z.string())])
				.optional()
				.catch(undefined),
			countryCode: z.string().optional().nullable().catch(undefined),
			pageNumber: z
				.union([z.string().transform((val) => positiveInteger(val)), z.number().transform((val) => Math.max(1, Math.floor(val)))])
				.catch(1)
				.default(1),
			sortBy: z.string().optional().nullable().catch(undefined),
			sortDirection: z.enum(['ASC', 'DESC']).optional().nullable().catch(undefined),
		})
		.catch({ pageNumber: 1 });
};

export type ParsedManageItemsParams = z.infer<ReturnType<typeof createManageItemsParamsSchema>>;

/**
 * Parses and validates manage-items params from a URL search string.
 * Guarantees that pageNumber will always be a valid positive integer.
 */
export const parseManageItemsParamsFromSearch = (search: string): ParsedManageItemsParams => {
	const schema = createManageItemsParamsSchema();
	const paramsObject = qs.parse(search, { ignoreQueryPrefix: true });
	const params = schema.parse(paramsObject);

	return params;
};
